import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        list: [], //table中的list显示数据
        pagination: {

        }, //分页相关的信息
        record: {}, //根据id查询的数据详情信息
    },

    getters: {

    },

    mutations: {
        save(state, action) {

            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
        }
    },

    actions: {

        key(context, payload) {
            return D.select({
                ...payload
            })
        },
        getvalues(context, payload) {
            return D.select({
                ...payload
            })
        },
        delkey(context, payload) {
            return D.del({
                ...payload
            })
        },
        delallkey(context, payload) {
            return D.del({
                ...payload
            })
        },
        routesend(context, payload) {
            return D.select({
                ...payload
            })
        },
        // 短信签名申请 列表
        routesendPage(context, payload){
            return D.select({
                ...payload
            })
        },

    }
}
